import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cluster-hosting',
  templateUrl: './cluster-hosting.component.html',
  styleUrls: ['./cluster-hosting.component.scss']
})
export class ClusterHostingComponent implements OnInit {
  constructor(
    public translate: TranslateService,
    public route:ActivatedRoute
  ) { }
  pricingLink = 'pricing-plan/cluster-hosting';
  logoImg=`../../../assets/imgs/logo/se2in_logo.png`;

  titleSectionProp: any = {
    class: 'text-center iq-title-box-2',
    title: '',
    titleIcon: ''
  };
  List: any[] = [
    {
      title: 'MariaDB',
      image: './assets/images/se-icons/mariadb.png',
      link: '/services',
      desc: 'MARIADB_SYNC_API_DESCRIPTION',
      style:'iq-icon-box iq-icon-box-style-4 text-center iq-box-shadow'
    },
    {
      title: 'CLUSER_ADVANTAGE',
      image: './assets/images/se-icons/cloud-it-department.png',
      link: '/services',
      desc: 'CLUSTER_EXPLANATION',
      style:'iq-icon-box iq-icon-box-style-4 text-center iq-box-shadow'
    },
    {
      title: 'Security',
      image: './assets/images/se-icons/data-security.png',
      link: '/services',
      desc: 'DB_SECURITY_DESCRIPTION',
      style:'iq-icon-box iq-icon-box-style-4 text-center iq-box-shadow'
    },
    {
      title: 'SQLite',
      image: './assets/images/se-icons/sqlite.png',
      link: '/services',
      desc: 'SQLITE_SYNC_API_DESCRIPTION',
      style:'iq-icon-box iq-icon-box-style-4 text-center iq-box-shadow'
    },
    {
      title: 'PRODUCT_JAVA_SYNC_API',
      image: './assets/images/se-icons/java-sync.png',
      link: '/services',
      desc: 'JAVA_SYNC_API_DESCRIPTION',
      style:'iq-icon-box iq-icon-box-style-4 text-center iq-box-shadow'
    },
    {
      title: 'PRODUCT_JAVASCRIPT_SYNC_API',
      image: './assets/images/se-icons/js-sync.png',
      link: '/services',
      desc: 'JAVA_SCRIPT_SYNC_API_DESCRIPTION',
      style:'iq-icon-box iq-icon-box-style-4 text-center iq-box-shadow'
    }
  ]

  ngOnInit(): void {
  }

}
